import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialDocumentService {

  constructor(private http: HttpClient) { }

  searchMaterialDocument(params:any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/materialDocument/queryMaterialDocument`;
    return this.http.post(url,params);
  }

  getMappingFacilityOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/facility/getMappingFacilityOptions/Wistron`;
    return this.http.get(url);
  }
}
